"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const AddressGroup_1 = tslib_1.__importDefault(require("./AddressGroup"));
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class OfferWithEstimatesPackage extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'The package id, used for reference later in the process',
        example: '054d9192-84b9-4b1a-b91c-6261a8d0eb7b',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    tslib_1.__metadata("design:type", String)
], OfferWithEstimatesPackage.prototype, "packageId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AddressGroup_1.default),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Array)
], OfferWithEstimatesPackage.prototype, "addressGroups", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.YearlyMonthlyValue),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", offerstore_api_models_1.YearlyMonthlyValue)
], OfferWithEstimatesPackage.prototype, "total", void 0);
exports.default = OfferWithEstimatesPackage;
